import React from 'react';
import { CommandBarButton, IconButton } from '@fluentui/react';
import DetailsTable from '../../../../Table/DetailsTable';
import FeatureSummary from '../../../../Util/FeatureSummary';

const ScholarshipsTable = ({
    scholarships,
    setSelectedScholarship,
    setSelectedScholarshipTitle,
    loading,
    editOnClick,
    previewOnClick,
    createOnClick,
    deleteOnClick,
}) => {
    const columns = [
        {
            minWidth: 30,
            maxWidth: 30,
            onRender: (item) => (
                <ContextualMenu editOnClick={editOnClick} previewOnClick={previewOnClick} id={item.scholarshipID} item={item} deleteOnClick={deleteOnClick} />
            ),
        },
        {
            name: 'ScholarshipID',
            fieldName: 'scholarshipID',
            minWidth: 120,
            maxWidth: 120,
            isResizable: true,
            isSorted: true,
            isSortedDescending: true,
        },
        {
            name: 'Published Status',
            fieldName: 'status',
            minWidth: 120,
            maxWidth: 120,
            isResizable: true,
            isSorted: true,
            isSortedDescending: true,
        },
        {
            name: 'Title',
            fieldName: 'title',
            minWidth: 300,
            maxWidth: 350,
            isResizable: true,
            isSorted: true,
            isSortedDescending: true,
        },
        {
            name: 'Sponsor',
            fieldName: 'sponsor',
            minWidth: 300,
            maxWidth: 350,
            isResizable: true,
            isSorted: true,
            isSortedDescending: true,
        },
        {
            name: 'Verified Year',
            fieldName: 'verifiedYear',
            minWidth: 120,
            maxWidth: 120,
            isResizable: true,
            isSorted: true,
            isSortedDescending: true,
        },
        {
            name: 'Multiple Deadlines',
            fieldName: 'multipleDeadlines',
            minWidth: 150,
            maxWidth: 150,
            isResizable: true,
            isSorted: true,
            isSortedDescending: true,
            onRender: (item) => item.multipleDeadlines > 1 ? 'Multiple' : '',
        },
        {
            name: 'Days Unverified',
            fieldName: 'daysUnverified',
            minWidth: 120,
            maxWidth: 120,
            isResizable: true,
            isSorted: true,
            isSortedDescending: true,
        },
        {
            name: 'Url',
            fieldName: 'url',
            minWidth: 300,
            maxWidth: 350,
            isResizable: true,
            isSorted: true,
            isSortedDescending: true,
            onRender: (item) =>
                item.url ? (
                    <a href={item.url} target="_blank" rel="noopener noreferrer">
                        {item.url}
                    </a>
                ) : null,
        },
    ];

    const items = scholarships ?? [];

    const selectionHook = (items) => {
        const selectedItem = items && items[0];
        setSelectedScholarship(selectedItem && selectedItem.scholarshipID);
        setSelectedScholarshipTitle?.(selectedItem?.title || "");
    };

    return (
        <>
            <DetailsTable
                items={items}
                columns={columns}
                selectionMode="none"
                selectionHook={selectionHook}
                loading={loading}
                mainColumn={'title'}
                style={{
                    position: 'relative',
                    height: '80vh',
                    width: '80vw',
                }}
                CommandBar={
                    <CommandBarButton
                        iconProps={{ iconName: 'Edit' }}
                        text="Add Scholarship"
                        onClick={() => createOnClick()}
                    />
                }
            />
            <FeatureSummary
                label="About Scholarships"
                summary="This table displays all scholarships, including their title, sponsor, status, and deadlines. You can add, edit, or delete scholarships. The Scholarship Inventory feature allows admins to manage and verify scholarships available to users."
                imageUrlPath='scholarships'
            />
        </>
    );
};

const moreIcon = { iconName: 'More' };

const ContextualMenu = ({ editOnClick, deleteOnClick, id, item, ...rest }) => {
    const menuProps = {
        items: [
            {
                key: 'print',
                iconProps: { iconName: 'Edit' },
                text: 'Edit',
                onClick: () => editOnClick(id),
            },
            {
                key: "Delete",
                iconProps: { iconName: "Delete" },
                text: "Delete",
                onClick: () => deleteOnClick(id, item?.title || item?.name || item?.slug || ""),
            },
        ],
    };

    return <IconButton iconProps={moreIcon} menuProps={menuProps} onRenderMenuIcon={() => {}} {...rest} />;
};

export default ScholarshipsTable;
